var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRaiseHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5703_32314)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.11133 15V10.6164C8.11133 10.2038 7.94742 9.80811 7.65568 9.51641C7.36394 9.22462 6.96825 9.06072 6.55566 9.06072C6.14307 9.06072 5.74739 9.22462 5.45564 9.51641C5.1639 9.80811 5 10.2038 5 10.6164V19.5914C5 21.6225 5.80689 23.5706 7.24317 25.0069C8.67944 26.4431 10.6275 27.25 12.6586 27.25H14.5877C16.2377 27.2499 17.8202 26.5945 18.9871 25.4278L20.6491 23.7659C21.6469 22.7677 22.2725 21.4634 22.431 20.07L22.4281 20.0952L22.4713 19.5914V16.7145C22.4715 16.6368 22.4869 16.5599 22.5168 16.4882C22.5466 16.4165 22.5904 16.3513 22.6454 16.2964L22.6544 16.2872C22.9342 15.993 23.0878 15.6012 23.0826 15.1954C23.0775 14.7895 22.9139 14.4018 22.6268 14.1148C22.3397 13.8278 21.9518 13.6645 21.5459 13.6596C21.1401 13.6547 20.7484 13.8086 20.4544 14.0885L20.4462 14.0965C19.7543 14.7876 19.3638 15.7242 19.36 16.7022V16.704V18.8734C19.36 18.9368 19.3348 18.9977 19.2899 19.0426C19.245 19.0874 19.1842 19.1127 19.1207 19.1127L16.8099 19.4088L15 20.5L18.8813 18.1554C18.8813 18.1554 18.8813 11.0712 18.8813 7.6248C18.8143 6.7632 18.0676 6.1888 17.3496 6.1888C16.7752 6.1888 16.0093 6.476 15.77 7.52906C15.77 8.0914 15.77 14.2 15.77 14.2L15.2913 14C15.2913 14 15.2913 6.66747 15.2913 6.1888C15.1669 5.02408 14.1329 4.7528 13.8457 4.75275C13.0801 4.70707 12.2757 5.23147 12.18 6.18876C12.18 6.64436 12.18 7.74439 12.18 7.74439V13.5H11.7013V7.74439C11.7013 7.3318 11.5374 6.93611 11.2456 6.64436C10.9539 6.35263 10.5583 6.18872 10.1457 6.18872C9.73306 6.18872 9.33738 6.35263 9.04563 6.64436C8.7539 6.93611 8.58999 7.3318 8.58999 7.74439V14.7L8.11133 15Z",
    stroke: "#242129",
    strokeOpacity: 0.27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6585 6.30844C12.6585 6.0228 12.7719 5.74886 12.9739 5.54689C13.1759 5.34492 13.4498 5.23145 13.7355 5.23145C14.0212 5.23145 14.2951 5.34492 14.4971 5.54689C14.699 5.74886 14.8125 6.0228 14.8125 6.30844V14.1767C15.3074 14.3318 15.789 14.5424 16.2485 14.8076V7.74444C16.2485 7.4588 16.3619 7.18486 16.5639 6.98288C16.7659 6.78091 17.0398 6.66744 17.3255 6.66744C17.6112 6.66744 17.885 6.78091 18.087 6.98288C18.289 7.18486 18.4025 7.4588 18.4025 7.74444V18.2148C17.7433 18.3264 17.119 18.5897 16.5791 18.9839C16.0391 19.3782 15.5982 19.8926 15.2912 20.4865C16.4811 19.8957 17.792 19.5893 19.1205 19.5914C19.3109 19.5914 19.4936 19.5158 19.6282 19.3811C19.7629 19.2465 19.8385 19.0638 19.8385 18.8734V16.7041C19.8418 15.8526 20.1818 15.0369 20.7843 14.4352C20.9879 14.2415 21.2591 14.1349 21.54 14.1383C21.821 14.1417 22.0895 14.2548 22.2883 14.4534C22.487 14.6521 22.6003 14.9205 22.6039 15.2015C22.6075 15.4824 22.5011 15.7538 22.3074 15.9574C22.2079 16.0566 22.1288 16.1744 22.0747 16.3042C22.0207 16.4339 21.9928 16.5731 21.9925 16.7137V19.5914H21.9877C21.9311 21.0355 21.3322 22.4053 20.3104 23.4274L18.6485 25.0894C17.5714 26.1663 16.1106 26.7713 14.5875 26.7714H12.6585C10.7543 26.7714 8.92799 26.0149 7.58148 24.6684C6.23498 23.3219 5.47852 21.4956 5.47852 19.5914V10.6164C5.47852 10.3308 5.59199 10.0569 5.79396 9.85487C5.99593 9.65288 6.26987 9.53943 6.55551 9.53943C6.84115 9.53943 7.11509 9.65288 7.31707 9.85487C7.51904 10.0569 7.63251 10.3308 7.63251 10.6164V15.8999C8.07288 15.4672 8.55633 15.1034 9.06851 14.8076V7.74444C9.06851 7.4588 9.18198 7.18486 9.38395 6.98288C9.58593 6.78091 9.85987 6.66744 10.1455 6.66744C10.4312 6.66744 10.7051 6.78091 10.9071 6.98288C11.1091 7.18486 11.2225 7.4588 11.2225 7.74444V13.992C11.6964 13.8962 12.177 13.8474 12.6585 13.8474V6.30844Z",
    fill: "url(#paint0_linear_5703_32314)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5703_32314",
    x: 0.5,
    y: 0.25,
    width: 27.083,
    height: 31.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.14902 0 0 0 0 0.164706 0 0 0 0 0.243137 0 0 0 0.29 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5703_32314"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5703_32314",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5703_32314",
    x1: 5.47852,
    y1: 5.23145,
    x2: 26.4642,
    y2: 21.9162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCF4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9B4A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaiseHand);
export default __webpack_public_path__ + "static/media/raise-hand.07a3ee6fb7c3769b4e24f08d25ff2181.svg";
export { ForwardRef as ReactComponent };